<template>
  <el-dialog
    :visible.sync="visible"
    width="600px"
    title="设置标签"
    custom-class="set-sign-container"
  >
    <el-tabs
      v-model="activeName"
      type="border-card"
      style="height: 200px"
      @tab-click="handleClick"
    >
      <template v-for="(item, index) in activeNames">
        <el-tab-pane :label="item.label" :name="item.label">
          <el-tag
            :key="index"
            style="margin-left: 5px"
            size="small"
            v-for="(tag, index) in item.value"
            closable
            @close="handleDeleteClose(item, tag)"
            >{{ tag }}
          </el-tag>
          <el-input
            class="input-new-tag"
            v-if="textVisible"
            v-model="textValue"
            style="width: 100px"
            size="mini"
            :id="item.label"
            :ref="item.label"
            clearable
            @keyup.enter.native="handleTextConfirm(item.label)"
            @blur="handleTextConfirm(item.label)"
          >
          </el-input>
          <el-button
            @click="focusTextInput(item.label)"
            size="mini"
            icon="el-icon-plus"
            circle
            style="margin-left: 5px"
          ></el-button>
        </el-tab-pane>
      </template>
    </el-tabs>

    <span slot="footer">
      <el-button type="success" class="button-wide" @click="commit"
        >确定</el-button
      >
      <el-button type="info" class="button-wide" @click="visible = false"
        >取消</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      visible: false,
      activeName: "",
      tabs: [],
      activeNames: [],
      textVisible: false,
      textValue: "",
    };
  },

  methods: {
    handleDeleteClose(tag, label) {
      this.activeNames.forEach((item) => {
        item.value = item.value.filter((list) => {
          return label != list;
        });
      });
    },

    commit(index) {
      // this.activeNames.push({label: "较不满意", value: []});
      // this.activeNames.push({label: "一般", value: []});
      // this.activeNames.push( {label: "满意", value: []});
      // this.activeNames.push({label: "非常满意", value: []});
      this.$emit("change", this.activeNames);
      this.$set(this, "activeNames", []);
      this.visible = false;
    },

    showTab(activeNames) {
      if (!activeNames || activeNames.length == 0) {
        this.$error("请先设置标签！");
      } else {
        this.visible = true;
        const arr = [];
        activeNames.forEach((item) => {
          arr.push({
            label: item,
            value: [],
          });
        });
        this.activeNames = arr;
        this.activeName = this.activeNames[0].label;
      }
    },

    showSigns(activeNames) {
      if (!activeNames || activeNames.length == 0) {
        this.$error("请先设置标签！");
      } else {
        this.visible = true;
        this.activeNames = activeNames;
        this.activeName = this.activeNames[0].label;
      }
    },

    handleClick(tab, event) {
      console.log(tab, event);
    },

    focusTextInput(refName) {
      this.textVisible = true;
      this.$nextTick(() => {
        document.getElementById(refName).focus();
      });
    },

    handleTextConfirm(label) {
      const index = this.activeNames.findIndex((item) => item.label == label);
      if (index != -1) {
        const flag = this.activeNames[index].value.indexOf(this.textValue);
        if (flag === -1) {
          this.activeNames[0].value.push(this.textValue);
          this.activeNames[1].value.push(this.textValue);
          this.activeNames[2].value.push(this.textValue);
        }
      }
      this.textVisible = false;
      this.textValue = "";
    },
  },
};
</script>

<style lang="scss">
.set-sign-container {
  & > .el-dialog__body {
    padding: 10px 15px;
  }
}
</style>



// WEBPACK FOOTER //
// src/avue/mixins/setRateTab.vue